"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeBundle = serializeBundle;
exports.bundleVisibilityLines = bundleVisibilityLines;
const SECTION_SEP = '\n\n---\n\n';
const DOT = ' · '; // " · "
function header(d) {
    if (d.missing) {
        return `### ⚠️ requires_load target missing: ${d.id}`;
    }
    let h = `### [${d.scope} ${d.type}] ${d.title}${DOT}id: ${d.id}`;
    if (d.stale)
        h += `${DOT}⚠️ stale: ${d.stale.reason}`;
    return h;
}
/**
 * Serialise a ContextBundle into the agent-agnostic markdown blob that gets
 * prepended to the AI prompt (context-pipeline design §5). One section per doc,
 * each led by a one-line provenance header; sections split by `---`. No
 * agent-specific hints — those belong in the per-command prompt template.
 */
function serializeBundle(bundle) {
    // Thread address (IN4): stamp the resolved weave_slug / thread_ulid into the
    // manifest header when present, so a caller that just read context can issue a
    // thread-scoped write without a second lookup.
    const addr = [
        bundle.weaveSlug ? `weave_slug=${bundle.weaveSlug}` : null,
        bundle.threadUlid ? `thread_ulid=${bundle.threadUlid}` : null,
    ].filter(Boolean).join(' ');
    const comment = `<!-- loom:context-bundle target=${bundle.targetId}${addr ? ` ${addr}` : ''} mode=${bundle.mode} docs=${bundle.docs.length} tokens~=${bundle.totalTokens} -->`;
    const sections = bundle.docs.map(d => {
        if (d.missing)
            return header(d);
        return `${header(d)}\n\n${d.content}`.trimEnd();
    });
    return [comment, ...sections].join(SECTION_SEP);
}
/**
 * The visibility lines for a bundle, walked from the SAME ordered docs[] the
 * serialiser uses — so the prompt and the visible record can never diverge
 * (context-pipeline design §5; consumed by showing-docs-loaded).
 */
function bundleVisibilityLines(bundle) {
    return bundle.docs.map(d => {
        if (d.missing)
            return `⚠️ requires_load target missing: ${d.id}`;
        const stale = d.stale ? ' (⚠️ stale)' : '';
        return `📄 ${d.title} — loaded for context${stale}`;
    });
}
